import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { environment } from '~environments/environment';
import { LogContext, Logger } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class ConsoleLoggerService implements Logger {
  constructor(private readonly route: ActivatedRoute) {}

  public debug(msg: string, context?: LogContext): void {
    if (this.isDebugMode()) {
      console.debug(msg, context);
    }
  }
  public error(msg: string, context?: LogContext): void {
    console.error(msg, context);
  }
  public info(msg: string, context?: LogContext): void {
    if (this.isDebugMode()) {
      console.info(msg, context);
    }
  }

  public isDebugMode(): boolean {
    return (
      !environment.production ||
      this.route.snapshot.queryParams?.debug === 'true'
    );
  }
  public warn(msg: string, context?: LogContext): void {
    if (this.isDebugMode()) {
      console.warn(msg, context);
    }
  }
}
